import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
@Component({ selector: 'app-adesao-plano-familia', templateUrl: './adesao-plano-familia.component.html', styleUrls: ['./adesao-plano-familia.component.css'] })
export class AdesaoPlanoFamiliaComponent {
    faSquareXmark = faSquareXmark;
    today = new Date();
    estadoCivilList: any[] = [{ desc: "Solteiro" }, { desc: "Casado" }, { desc: "Separado" }, { desc: "Divorciado" }, { desc: "Viúvo" }];
    tipoDocumentoList: any[] = [{ desc: "RG" }, { desc: "CNH" }, { desc: "Certidão de Nascimento" }, { desc: "Registro Profissional" }, { desc: "Registro de Estrangeiro" }];
    sexoList: any[] = [{ desc: "Masculino" }, { desc: "Feminino" }];
    tipoEnderecoList: any[] = [{ desc: "Residencial" }, { desc: "Comercial" }];
    diaVencimentoList: any[] = [{ desc: "15" }, { desc: "25" }];
    tipoPagamentoList: any[] = [{ desc: "Débito" }, { desc: "Boleto Bancário" }, { desc: "Desconto em Folha" }];
    simNaoList: any[] = [{ desc: "Sim" }, { desc: "Não" }];
    tributacaoList: any[] = [{ desc: "Progressivo" }, { desc: "Regressivo" }];
    loading: any = false;
    // completo: any = true;
    completo: any = false;
    listaDocumentos: Array<{ fileName: string, evento: any }> = [];
    formData: FormGroup = new FormGroup({
        indicador: new FormControl(null),
        nome: new FormControl(null, [Validators.required, Validators.pattern('^.{3,}( .{2,})+$')]),
        email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
        celular: new FormControl(null, [Validators.required])
    });
    formCompleto: FormGroup = new FormGroup({
        indicador: new FormControl(null),
        nome: new FormControl(null, [Validators.required, Validators.pattern('^.{3,}( .{2,})+$')]),
        email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
        celular: new FormControl(null),
        telefone: new FormControl(null),
        email2: new FormControl(null),
        cpf: new FormControl(null, [Validators.required]),
        dt_nascimento: new FormControl(null, [Validators.required]),
        tipo_documento: new FormControl(null, [Validators.required]),
        documento: new FormControl(null, [Validators.required]),
        orgao_expedidor: new FormControl(null, [Validators.required]),
        dt_expedicao: new FormControl(null, [Validators.required]),
        nome_pai: new FormControl(null),
        nome_mae: new FormControl(null, [Validators.required, Validators.pattern('^.{3,}( .{2,})+$')]),
        sexo: new FormControl(null, [Validators.required]),
        estado_civil: new FormControl(null, [Validators.required]),
        profissao: new FormControl(null, [Validators.required]),
        vl_renda: new FormControl(null, [Validators.required]),
        nacionalidade: new FormControl('Brasileiro(a)', [Validators.required]),
        naturalidade: new FormControl(null, [Validators.required]),
        politicamente_exposto: new FormControl('Não', [Validators.required]),
        cpf_conjuge: new FormControl(null),
        nome_conjuge: new FormControl(null),
        idade: new FormControl(null),
        cpf_representante: new FormControl(null),
        nome_representante: new FormControl(null),
        cep: new FormControl(null, [Validators.required]),
        endereco: new FormControl(null, [Validators.required]),
        complemento: new FormControl(null),
        numero: new FormControl(null, [Validators.required]),
        bairro: new FormControl(null, [Validators.required]),
        cidade: new FormControl(null, [Validators.required]),
        estado: new FormControl(null, [Validators.required]),
        pais: new FormControl(null, [Validators.required]),
        endereco_principal: new FormControl('Sim', [Validators.required]),
        tipo_endereco2: new FormControl('Residencial'),
        cep2: new FormControl(null),
        endereco2: new FormControl(null),
        complemento2: new FormControl(null),
        numero2: new FormControl(null),
        bairro2: new FormControl(null),
        cidade2: new FormControl(null),
        estado2: new FormControl(null),
        pais2: new FormControl(null),
        tipo_pagamento: new FormControl('Boleto Bancário', [Validators.required]),
        dia_vencimento: new FormControl('25', [Validators.required]),
        idade_beneficio: new FormControl(null, [Validators.required]),
        vl_contribuicao: new FormControl(null, [Validators.required]),
        vl_risco_invalidez: new FormControl(null, [Validators.required]),
        vl_risco_morte: new FormControl(null, [Validators.required]),
        tipo_tributacao: new FormControl('Regressivo', [Validators.required])
    });
    constructor(private http: HttpClient, private route: ActivatedRoute) {
        this.loading = true;
        this.route.queryParams.subscribe((params: any) => {
            this.formData.get('indicador')!.setValue(params.code);
            this.loading = false;
        });
    }
    save() {
        this.loading = true;
        const url = `${environment.portalApi}/PlanoFamilia/InsereConvidado`;
        let form = this.completo ? this.formCompleto.value : this.formData.value;
        form.documentos = this.listaDocumentos;
        this.http.post(url, form, { headers: new HttpHeaders({ 'content-type': 'application/json' }) }).subscribe((res: any) => {
            this.loading = false;
            Swal.fire({
                title: 'Sucesso!',
                text: 'Solicitação realizada com sucesso!',
                icon: 'success',
                showConfirmButton: true
            }).then(() => {
                this.formData.reset();
                this.formCompleto.reset();
            });
        }, (error: any) => {
            this.loading = false;
            if (error.error.Message) {
                Swal.fire({
                    title: error.error.Message.split('||')[0],
                    text: error.error.Message.split('||')[1],
                    icon: 'error',
                    showConfirmButton: true
                }).then(() => { });
            } else {
                Swal.fire({
                    title: 'Erro!',
                    text: 'Solicitação não realizada, favor tentar novamente ou entrar em contato com a central de atendimento!',
                    icon: 'error',
                    showConfirmButton: true
                }).then(() => { });
            }
        }
        );
    }
    continue() {
        this.completo = true;
        this.formCompleto.get('indicador')!.setValue(this.formData.value.indicador);
        this.formCompleto.get('nome')!.setValue(this.formData.value.nome);
        this.formCompleto.get('email')!.setValue(this.formData.value.email);
        this.formCompleto.get('celular')!.setValue(this.formData.value.celular);
    }
    calculaIdade() {
        let dt_nascimento = this.formCompleto.get('dt_nascimento')?.value;
        if (dt_nascimento == null || dt_nascimento == undefined) return;
        let dataNascimento = new Date(this.formCompleto.get('dt_nascimento')?.value);
        if (dataNascimento.getFullYear() <= 1900) return;
        let now = new Date();
        let idadeAtual = (now.getFullYear() - dataNascimento.getFullYear());
        now.setFullYear(now.getFullYear() - idadeAtual);
        if (now < dataNascimento) idadeAtual = idadeAtual - 1;
        if (idadeAtual < 18) {
            this.formCompleto.controls['cpf_representante'].setValidators([Validators.required]);
            this.formCompleto.controls['nome_representante'].setValidators([Validators.required]);
        } else {
            this.formCompleto.controls['cpf_representante'].clearValidators();
            this.formCompleto.controls['nome_representante'].clearValidators();
        }
        this.formCompleto.get('idade')!.setValue(idadeAtual);
    }
    cepChanged() {
        if (this.formCompleto && this.formCompleto.value.cep && this.formCompleto.value.cep.length == 8) {
            const url = `https://viacep.com.br/ws/${this.formCompleto.get('cep')?.value}/json`;
            this.http.get(url, { headers: new HttpHeaders({ 'content-type': 'application/json' }) })
                .subscribe((res: any) => {
                    if (res.localidade) {
                        if (res.logradouro) {
                            this.formCompleto.get('endereco')?.setValue(res.logradouro.toUpperCase());
                            this.formCompleto.get('endereco')?.disable();
                        } else {
                            this.formCompleto.get('endereco')?.setValue(null);
                            this.formCompleto.get('endereco')?.enable();
                        }
                        this.formCompleto.get('cidade')?.setValue(res.localidade.toUpperCase());
                        this.formCompleto.get('cidade')?.disable();
                        this.formCompleto.get('estado')?.setValue(res.uf.toUpperCase());
                        this.formCompleto.get('estado')?.disable();
                        if (res.bairro) {
                            this.formCompleto.get('bairro')?.setValue(res.bairro.toUpperCase());
                            this.formCompleto.get('bairro')?.disable();
                        } else {
                            this.formCompleto.get('bairro')?.setValue(null);
                            this.formCompleto.get('bairro')?.enable();
                        }
                        this.formCompleto.get('pais')?.setValue('BRASIL');
                        this.formCompleto.get('pais')?.disable();
                        this.formCompleto.updateValueAndValidity();
                    } else {
                        this.formCompleto.get('cep')?.setErrors({ 'incorrect': true });
                        this.formCompleto.get('address')?.setValue(null);
                        this.formCompleto.get('address')?.enable();
                        this.formCompleto.get('cidade')?.setValue(null);
                        this.formCompleto.get('estado')?.setValue(null);
                        this.formCompleto.get('bairro')?.setValue(null);
                        this.formCompleto.get('bairro')?.enable();
                        this.formCompleto.get('pais')?.setValue('BRASIL');
                    }
                });
        } else {
            this.formCompleto.get('endereco')?.setValue(null);
            this.formCompleto.get('cidade')?.setValue(null);
            this.formCompleto.get('bairro')?.setValue(null);
            this.formCompleto.get('estado')?.setValue(null);
        }
    }
    setEndereco2() {
        if (this.formCompleto.get('endereco_principal')?.value != 'Sim') {
            this.formCompleto.controls['cep2'].setValidators([Validators.required]);
            this.formCompleto.controls['endereco2'].setValidators([Validators.required]);
            this.formCompleto.controls['numero2'].setValidators([Validators.required]);
            this.formCompleto.controls['bairro2'].setValidators([Validators.required]);
            this.formCompleto.controls['cidade2'].setValidators([Validators.required]);
            this.formCompleto.controls['estado2'].setValidators([Validators.required]);
            this.formCompleto.controls['pais2'].setValidators([Validators.required]);
            this.formCompleto.controls['tipo_endereco2'].setValidators([Validators.required]);
        } else {
            this.formCompleto.controls['cep2'].clearValidators();
            this.formCompleto.controls['endereco2'].clearValidators();
            this.formCompleto.controls['numero2'].clearValidators();
            this.formCompleto.controls['bairro2'].clearValidators();
            this.formCompleto.controls['cidade2'].clearValidators();
            this.formCompleto.controls['estado2'].clearValidators();
            this.formCompleto.controls['pais2'].clearValidators();
            this.formCompleto.controls['tipo_endereco2'].clearValidators();
        }
    }
    cep2Changed() {
        if (this.formCompleto && this.formCompleto.value.cep2 && this.formCompleto.value.cep2.length == 8) {
            const url = `https://viacep.com.br/ws/${this.formCompleto.get('cep2')?.value}/json`;
            this.http.get(url, { headers: new HttpHeaders({ 'content-type': 'application/json' }) })
                .subscribe((res: any) => {
                    if (res.localidade) {
                        if (res.logradouro) {
                            this.formCompleto.get('endereco2')?.setValue(res.logradouro.toUpperCase());
                            this.formCompleto.get('endereco2')?.disable();
                        } else {
                            this.formCompleto.get('endereco2')?.setValue(null);
                            this.formCompleto.get('endereco2')?.enable();
                        }
                        this.formCompleto.get('cidade2')?.setValue(res.localidade.toUpperCase());
                        this.formCompleto.get('cidade2')?.disable();
                        this.formCompleto.get('estado2')?.setValue(res.uf.toUpperCase());
                        this.formCompleto.get('estado2')?.disable();
                        if (res.bairro) {
                            this.formCompleto.get('bairro2')?.setValue(res.bairro.toUpperCase());
                            this.formCompleto.get('bairro2')?.disable();
                        } else {
                            this.formCompleto.get('bairro2')?.setValue(null);
                            this.formCompleto.get('bairro2')?.enable();
                        }
                        this.formCompleto.get('pais2')?.setValue('BRASIL');
                        this.formCompleto.get('pais2')?.disable();
                        this.formCompleto.updateValueAndValidity();
                    } else {
                        this.formCompleto.get('cep2')?.setErrors({ 'incorrect': true });
                        this.formCompleto.get('address2')?.setValue(null);
                        this.formCompleto.get('address2')?.enable();
                        this.formCompleto.get('cidade2')?.setValue(null);
                        this.formCompleto.get('estado2')?.setValue(null);
                        this.formCompleto.get('bairro2')?.setValue(null);
                        this.formCompleto.get('bairro2')?.enable();
                        this.formCompleto.get('pais2')?.setValue('BRASIL');
                    }
                });
        } else {
            this.formCompleto.get('endereco2')?.setValue(null);
            this.formCompleto.get('cidade2')?.setValue(null);
            this.formCompleto.get('bairro2')?.setValue(null);
            this.formCompleto.get('estado2')?.setValue(null);
        }
    }
    adicionarArquivos(evento: any) {
        evento.forEach((doc: any) => {
            this.listaDocumentos.push(doc);
        });
    }
    removeFile(position: number) {
        this.listaDocumentos.splice(position, 1);
    }
}